module.exports = __webpack_public_path__ + "static/img/character.f0118da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/character.png
// module id = h5NP
// module chunks = 1